import { styled } from 'styled-components';
import ButtonCheck from './ButtonCheck';
import ButtonGroup from './ButtonGroup';
import RadioCounter from './RadioCounter';
import TextInput from './TextInput';
import FileInput from './FileInput';

import FormRow from './FormRow';

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spaceSm};
`;

const Label = styled.label`
  font-size: ${props => props.theme.sizeSmall};
  font-weight: ${props => props.theme.headerWeight};
  letter-spacing: ${props => props.theme.headerSpacing};
  text-transform: uppercase;
`;

export { ButtonCheck, ButtonGroup, RadioCounter, TextInput, FileInput,  FormRow, InputGroup, Label };
